import useDjangoWaffle from "@shared/hooks/djangoWaffle/useDjangoWaffle";
import UserInteractionLogger from "@shared/lib/analytics/internal/UserInteractionLogger";
import { PublicInternalAnalyticsTrackingSerializerWithLabelString } from "../types";

export const useHandleUserInteractionLogger = () => {
  const { FLAGS } = useDjangoWaffle();

  const trackButtonClick = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    analytics: Omit<
      PublicInternalAnalyticsTrackingSerializerWithLabelString,
      "interaction_type"
    > = {} // label for button click and box view is not validated so can be any string.
  ) => {
    if (!FLAGS?.track_button_click) {
      return null;
    }
    const analyticsData = analytics;
    const buttonText = event?.currentTarget?.innerText;
    if (buttonText) {
      analyticsData.custom_params = {
        ...analyticsData.custom_params,
        button_text: buttonText,
      };
    }

    return UserInteractionLogger.buttonClick(analyticsData);
  };

  const trackImpression = (
    analytics: Omit<
      PublicInternalAnalyticsTrackingSerializerWithLabelString,
      "interaction_type"
    >
  ) => {
    const areParamsUndefined = Object.values(analytics).some(
      (param) => param === undefined
    );
    if (!areParamsUndefined) {
      return UserInteractionLogger.impression(analytics);
    }
    return null;
  };

  return { trackButtonClick, trackImpression };
};
